// Does this visitor have an account, or only a conversation?
//
// Every visitor is handed a guest identity so they can ask something without
// signing up, and that sets `isLoggedIn` — the socket will not connect without
// it. So `isLoggedIn` answers "is there an identity", not "is there an account",
// and two screens read it as the second: the sign-in screen decided the visitor
// was already signed in and sent them back to the chat, making sign-in
// unreachable; ProtectedRoute let every visitor through, because every visitor
// is a guest.
//
// The distinction is already written into the store, next to `isGuest`:
// "Signed in only as far as the conversation goes: a visitor with a guest
// token. Profile, basket and history stay behind a real sign-in."
//
// Kept as a function of its own so the rule is stated once and can be read
// without a browser, rather than spelled out at each place that needs it.

/**
 * @param {{isLoggedIn?: boolean, isGuest?: boolean}} auth the auth slice
 * @returns {boolean} true only for a real account — never for a guest
 */
export function isSignedIn(auth) {
  return Boolean(auth && auth.isLoggedIn && !auth.isGuest);
}

export default isSignedIn;
